import React from "react";
import { Button, Spinner } from "react-bootstrap";

const UpdateAppModal = ({ isLoading, onRefresh }) => {
  return (
    <div className="sw_popup_overlay">
      <div className="sw_popup_content">
        <p>A new version of the App is available.</p>
        <p>Please tap Refresh to update!</p>
        <Button disabled={isLoading} onClick={onRefresh}>
          {isLoading && <Spinner size="sm" className="me-2" />}
          Refresh
        </Button>
      </div>
    </div>
  );
};

export default UpdateAppModal;
